import type { Page } from '../../types';

const otherBenefits: Page[] = [
  {
    pageType: 'question',
    title: 'Other benefits',
    name: 'other-benefits-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any other benefits to declare?',
        name: 'other_benefits_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Other benefits',
    name: 'other-benefits',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [{ title: 'Total Value', field: 'other_benefits' }],
    },
    disabled: [
      {
        field: 'other_benefits_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'other_benefits',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'other_benefits_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default otherBenefits;
